export default __webpack_public_path__ + "static/media/b_wdt_c_2.ceb83dbc.mp3";